import { useTheme } from '@mui/material/styles';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormEventHandler } from 'react';

type WarningModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onSubmit: FormEventHandler<HTMLFormElement>;
};

const WarningModal = ({ isOpen, setIsOpen, onSubmit }: WarningModalProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation();

  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      aria-labelledby="responsive-dialog-title"
      fullWidth
    >
      <DialogTitle id="responsive-dialog-title">
        {t('Attention', { defaultValue: 'Attention' })}
      </DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={onSubmit} noValidate sx={{ mt: '1rem' }}>
          <Alert severity="warning">
            <Typography>
              {t('Attention! The start date does not match the planned schedule!', {
                defaultValue: 'Attention! The start date does not match the planned schedule!',
              })}
            </Typography>
          </Alert>
          <Button variant="contained" type="submit" fullWidth sx={{ mt: '1rem' }}>
            {t('Confirm', { defaultValue: 'Confirm' })}
          </Button>
          <Button variant="outlined" fullWidth sx={{ mt: '1rem' }} onClick={() => setIsOpen(false)}>
            {t('Cancel', { defaultValue: 'Cancel' })}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WarningModal;
